import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';

import { AddButton } from 'components/_basic/Form/FieldArray/components/AddButton';
import { RemoveButton } from 'components/_basic/Form/FieldArray/components/RemoveButton';
import { FormSectionCard } from 'components/_basic/FormSectionCard/FormSectionCard';
import { ProductVolumeIn } from 'components/BusinessToolForm/components/ProductVolumeIn';

import { ProductionVolumeItem } from './ProductionVolumeItem';
import { IProductVolumesProps } from './types';

import styles from './ProductVolumes.module.scss';

const MAX_LENGTH = 5;

export const ProductVolumes: React.FC<IProductVolumesProps> = ({
  productsName: name,
  fields,
  disabled,
  onAddRow,
  onRemoveRow,
}) => {
  const { t } = useTranslation();

  const canAddMore = fields.length < MAX_LENGTH;
  const canRemove = fields.length > 1;

  return (
    <FormSectionCard disabled={disabled} title={t('businessOperations.production.productVolume.title')} collapsible>
      <Box>
        {fields.map((item, index) => {
          const productName = `${name}.${index}`;
          return (
            <Box key={item.id} className={styles.rowContainer}>
              <Box className={styles.rowChildren}>
                <ProductVolumeIn productName={productName} disabled={disabled} />
                <ProductionVolumeItem name={productName} disabled={disabled} />
              </Box>
              <RemoveButton canRemove={canRemove} disabled={disabled} onClick={() => onRemoveRow(index)} />
            </Box>
          );
        })}
      </Box>
      <AddButton canAddMore={canAddMore} onClick={onAddRow} disabled={disabled} variant="text">
        {t('businessOperations.production.productVolume.product')}
      </AddButton>
    </FormSectionCard>
  );
};
